// extracted by mini-css-extract-plugin
export default {"ChatPageContainer":"chatlayout_ChatPageContainer__GSqMI","ChatPageContent":"chatlayout_ChatPageContent__NPSkv"};